export { default as ClassPassEdit } from './ClassPassEdit';

